import {Storage as Store} from '@capacitor/storage';
import store from "@/store";


//Users
export const CurrentUser = 'current_user';
export const SESSION_ID = 'sessionID';
export const AllUsers = 'all_users';
export const CURRENT_USER = 'loggedInUser'
export const CURRENT_SESSION = 'sessionID'


const encryptAdmin = (val) => {
    return window.btoa(val);
}
const decryptAdmin = (val) => {
    if (!val) return undefined;
    if (val.toString().charAt(0)===`"`){
        val = val.toString().slice(1, -1);
    }
    return JSON.parse(window.atob(val))
}

const setValue = (key, value) => Store.set({key: key, value: JSON.stringify(value)})

const getValue = async (key) => {
    const value = await Store.get({
        key: key
    })
    return JSON.parse(value.value);
}

export const Storage = {
    setCurrentUser: async (payload) => {
        await Store.set({
            key: CurrentUser, value: JSON.stringify(payload)
        })
    },
    getCurrentUser: async () => {
        let value = store.getters.getCurrentUser;
        if (value) return value;

        value = await Store.get({
            key: CurrentUser
        })
        return JSON.parse(value.value);
    },
    setUsers: async (payload) => {
        await Store.set({
            key: AllUsers, value: JSON.stringify(payload)
        })
    },
    getAllUsers: async () => {
        const value = await Store.get({
            key: AllUsers
        })
        return JSON.parse(value.value);
    },

    //Users
    // setCurrentUser: async (payload) => setValue(CURRENT_USER, payload),
    // getCurrentUser: async () => getValue(CURRENT_USER),

    getSessionID: async () => getValue(CURRENT_SESSION),
    setSessionID: async (data) => setValue(CURRENT_SESSION, data),
}
